import { render, staticRenderFns } from "./MemberFollow.vue?vue&type=template&id=699aadec&scoped=true&"
import script from "./MemberFollow.vue?vue&type=script&lang=js&"
export * from "./MemberFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699aadec",
  null
  
)

component.options.__file = "MemberFollow.vue"
export default component.exports